// extracted by mini-css-extract-plugin
export default {"relateVideo":"index_relateVideo_f2iSz"};